import notify from '../components/notify';

const excludeCodes = [
  'REFRESH_TOKEN_INVALID',
  'REFRESH_TOKEN_EXPIRED',
  'CSRF_TOKEN_INVALID',
];

interface Error {
  code: string,
  message: string,
}

export default function onError(error: Error) {
  if (excludeCodes.includes(error.code)) return;
  const message = error.message || `An unexpected error occurred. Code: ${error.code}`;
  notify({
    color: 'negative',
    message,
  });
}
